export default __webpack_public_path__ + "static/media/Arrow-icon.4e93b206.svg";